import { Pipe, PipeTransform } from '@angular/core';
import { ExperimentTypeDisplayName } from '../services/labpartner.service.model';

@Pipe({
  name: 'icExperimentFormat',
  standalone: false,
})
export class ICExperimentFormatPipe implements PipeTransform {
  experimentTypeDisplayNameValues = Object.values(ExperimentTypeDisplayName);

  transform(experimentId: number): string {
    return `${experimentId.toString().padStart(5, '0')}`;
  }
}
